export const language = {
	text: 'There is nothing here... yet..',
};
